import { styled } from '@linaria/react'
import { EverGreenStyle } from '@utils/Style/everGreen'
import React, { ButtonHTMLAttributes, HTMLAttributes } from 'react'

interface IFlatButtonProps extends React.PropsWithoutRef<ButtonHTMLAttributes<HTMLButtonElement>>{
    isActive?:boolean;
    maxWidth:string;
} 

function FlatButton({isActive=true ,...props}: IFlatButtonProps) {
  return (
    <Button isActive={isActive} {...props} />
  )
}

export default FlatButton

const Button = styled.button<{isActive:boolean, maxWidth:string}>`
height: 52px;
display: flex;
justify-content: center;
align-items: center;
background-color: ${props=>props.isActive? EverGreenStyle.colors.primary :EverGreenStyle.colors.grey[700]};
cursor: pointer;
padding: 8px;
width: 100%;
max-width: ${props=>props.maxWidth}'px';
font-size: 12px;
font-style: normal;
font-weight: 600;
line-height: 140%;
color: ${props=>props.isActive? EverGreenStyle.colors.white : EverGreenStyle.colors.grey[1200]};
border: ${props=>props.isActive? EverGreenStyle.colors.primary :EverGreenStyle.colors.grey[700]} solid;
border-radius: 8px;
transition: all 0.3s linear;
&:hover{
    background-color: ${EverGreenStyle.colors.primary};
border: ${EverGreenStyle.colors.primary} solid;
color: ${EverGreenStyle.colors.white};
}

`